/**
 * Fetches sections/product-recommendations.liquid's own rendered output
 * from Shopify's native recommendations endpoint (Section Rendering —
 * see the data-url built in that section) once it's near the viewport,
 * and swaps it in. Real product-card.liquid markup comes back from the
 * server; this file never renders a product card itself. If the
 * endpoint returns no results the section already renders empty/hidden
 * server-side, so there is nothing to swap.
 */
(function initProductRecommendations() {
  const sections = document.querySelectorAll('[data-product-recommendations]');
  if (sections.length === 0) return;

  async function load(section) {
    const url = section.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.getElementById(section.id);
      if (fresh && fresh.innerHTML.trim() !== '') {
        section.innerHTML = fresh.innerHTML;
        section.classList.remove('product-recommendations--empty');
      }
    } catch (error) {
      /* leave the section in its empty server-rendered state */
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    },
    { rootMargin: '400px 0px' }
  );
  sections.forEach((section) => observer.observe(section));
})();
